<div class="p8-bdc_doc-picker__doc-container" fxLayout="row wrap">
  <p8-bdc-document-new></p8-bdc-document-new>
</div>
